module.exports = __webpack_public_path__ + "img/sidebar-icon-project.452e7fea.svg";